// @flow
import { normalizeOptions } from "Commons/Components/FormComponents/utils";
import {
  AUTOMATIC_CANCELLATION,
  CANCELLED_ALREADY,
  CUSTOM_SWITCHING_DATE,
  NEXT_POSSIBLE_DATE,
  FIRST_OCCUPANCY,
  MOVE,
  RELOCATION,
  SWITCH_PROVIDER,
  ME,
  FAMILY_FRIENDS,
  OTHERS,
  YES,
  NO,
} from "./Constants";
import type { OptionT } from "Commons/Components/FormComponents/misc/Types";
import i18n from "./../../../i18n";
import { HOUSE, APT, COMPANY } from "Commons/Utilities/Constants/PropertyTypes";

function getLabel(property: string, option: string) {
  return i18n.t(`changeService:wizard.customer.${property}.options.${option}`);
}
function getLabelContract(property: string, option: string) {
  return i18n.t(`changeService:wizard.contract.${property}.options.${option}`);
}

const normalize = normalizeOptions(getLabel);
const normalizeContract = normalizeOptions(getLabelContract);

type ReasonForChangeOptionsType = {
  firstOccupancy: OptionT[],
  switchProviderOrMove: OptionT[],
};

export const ReasonForChangeOptions = (normalize({
  firstOccupancy: [RELOCATION, FIRST_OCCUPANCY],
  switchProviderOrMove: [SWITCH_PROVIDER, MOVE],
}): ReasonForChangeOptionsType);

type DeliveryAddressOptionsType = {
  billingAddressSameAsDeliveryAddress: OptionT[],
};

export const DeliveryAddressOptions = (normalize({
  billingAddressSameAsDeliveryAddress: [YES, NO],
}): DeliveryAddressOptionsType);

type onBehalfOfOptionsType = {
  onBehalfOf: OptionT[],
};

export const onBehalfOfOptions = (normalize({
  onBehalfOf: [ME, FAMILY_FRIENDS, OTHERS],
}): onBehalfOfOptionsType);

type propertyTypeOptionsT = {
  propertyType: OptionT[],
};

export const propertyTypeOptions = (normalize({
  propertyType: [HOUSE, APT, COMPANY],
}): propertyTypeOptionsT);

type ContractOptionsType = {
  cancellationContractType: OptionT[],
  moveWithPreviousProvider: OptionT[],
  switchTariffDateType: OptionT[],
  ecoTariff: OptionT[],
};

export const ContractOptions = (normalizeContract({
  cancellationContractType: [AUTOMATIC_CANCELLATION, CANCELLED_ALREADY],
  moveWithPreviousProvider: [YES, NO],
  switchTariffDateType: [NEXT_POSSIBLE_DATE, CUSTOM_SWITCHING_DATE],
  ecoTariff: ["true"],
}): ContractOptionsType);
